export default "__VITE_PUBLIC_ASSET__05cc9572__"